module.exports = __webpack_public_path__ + "img/Threshold.ccf8b1d5.png";